export default "DETR & DSIL — Collectivités | Solution Éco France";
